<template>
    <transition name="modal">
        <div class="feature-modal-mask" :class="{'modal-mask': !isfeaturedetail}">
            <div id="featuremodalwrapper" class="featuremodal" :class="{'modal-wrapper': !isfeaturedetail}">
                <div :class="{'modal-container': !isfeaturedetail, 'feature-detail-block': isfeaturedetail}">
                    <div class="feature-detail-preview">
                        <div class="feature-detail-item" :style="'background-image: url('+selectedfeature.blockimage+')'"></div>
                    </div>
                    <div class="feature-detail-content">
                        <div class="feature-detail-content-block feature-detail-main-text" @click.prevent="toggleFeaturePreview('on')" >
                            <a class="navbar-brand" href="/" v-if="isfeaturedetail">
                                <span v-if="sitedata.settings[0].logoimage" class="logo-container">
                                    <img :src="sitedata.settings[0].logoimage" alt="sitedata.name" class="logoimage"/>
                                </span>
                                <span v-else class="edited_content">
                                    {{ sitedata.name }}
                                </span>
                            </a>
                            <button v-else style="width: 48px; height: 48px;" class="btn btn-ico btn-outline-white" @click="$emit('close')"><span class="material-icons">arrow_back</span></button>
                            
                            <h2 class="display-3 feature-detail-title">{{selectedfeature.pagetitle}}</h2>
                            <p class="feature-detail-price">€ 240</p>
                            <p class="feature-detail-description">{{selectedfeature.pagetext}}</p>

                            <div class="feature-detail-main-tabs">
                                <button class="btn btn-outline-white">Specificaties</button>
                                <button class="btn btn-outline-white">Reviews</button>
                            </div>
                        </div>
                        <button @click.prevent="toggleFeaturePreview('on')" class="btn btn-lg btn-white feature-detail-preview-button"><span class="material-icons ico">search</span> Bekijken</button>

                        <div class="feature-detail-content-block feature-detail-extra-block">
                            <h2 class="flex_fill display-5">Specificaties</h2>
                            <p class="display-7">Hier komen alle specificaties</p>
                        </div>

                        <div class="feature-detail-content-block feature-detail-extra-block">
                            <h2 class="flex_fill display-5">Reviews</h2>
                            <p class="display-7">Hier komen alle reviews</p>
                        </div>
                    </div>
                    <button class="btn btn-lg btn-primary feature-detail-buy-button">Kopen</button>
                    <button v-if="!readonly" class="btn btn-secondary btn-ico btn-feature-background" @click.prevent="imageModal = true, getimages()" ><span class="ico material-icons">photo_camera</span></button>
                </div>
            </div>

            <modal v-if="imageModal" @close="imageModal = false" title="Add image">
                <ul class="imageselector">
                    <li>
                        <upload-modal @clicked="getimages()" :websiteid="websiteid" thestyle="imageuploadbutton btn btn-primary"><span class="material-icons ico">add_circle</span> Upload</upload-modal>
                    </li>
                    <li v-for="image in images">
                        <button class="imagethumb" @click.prevent="setblockimage(image.image)" :style="'background-image: url('+ imageroot + image.image.split('uploads/').pop() +')'">
                            <span>{{ image.image }}</span>
                        </button>
                    </li>
                </ul>
                <form v-if="!readonly" id="blockimage" @submit.prevent="changeBlockSetting('blockimage', selectedfeature.blockimage)">
                    <button type="submit" class="btn btn-primary">Opslaan</button>
                </form>
            </modal>
        </div>
    </transition>
</template>

<script>
import ItemAdder from '../app/ItemAdder.vue';
import Modal from '../modal/Modal.vue';
import UploadModal from '../modal/UploadModal.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components: {
        ItemAdder,
        Modal,
        UploadModal
    },
    props: {
        content: String,
        pageid: String,
        websiteid: String,
        readonly: Boolean,
        isfeaturedetail: Boolean,
        sitedata: Object
    },
    data: function() {
        return{
            readonly: false,
            showFeaturePreview: false,
            showModal: false,
            showFeatureModal: false,
            selectedfeature: [],
            file: '',
            images: [],
            imageModal: false,
            imageroot: process.env.VUE_APP_ROOT_API + '/',
            pages: {}
        }
    },
    methods: {
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        setblockimage(image){
            this.selectedfeature.blockimage = this.imageroot+image.split("uploads/").pop()
        },
        setblockimagestyle(){
            if(this.selectedfeature.blockimage == null || this.selectedfeature.blockimagestyle == 'imgempty'){
                this.blockimagestyle = 'imgbg'
            }
        },
        getimages(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
            .then(response => {
                this.images = response.data.response
            })
        },
        changeBlockSetting(thedbentry, thecontent){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                pageid: this.pageid,
                dbentry: thedbentry,
                content: thecontent
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
            .then(response => {
                if(thedbentry == 'blockalign'){
                    this.content.blockalign = thecontent
                } 
                if (thedbentry == 'blockheight') {
                    this.content.blockheight = thecontent
                }
                if (thedbentry == 'blockfontsize') {
                    this.content.blockfontsize = thecontent
                }
                if (thedbentry == 'blockimage') {
                    this.$emit('clicked')
                    this.imageModal = false
                }
                if (thedbentry == 'seocanon') {
                    this.msgclass = 'success'
                    this.msgtext = 'Wijzigingen opgeslagen'
                }
            })
        },
        selectfeature(id){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageid/'+id)
            .then(response => {
                this.selectedfeature = response.data.response
                this.showFeatureModal = true
            })
        },
        toggleFeaturePreview(){
            var element = document.getElementById("featuremodalwrapper");
            element.classList.toggle("feature-preview-on");
        },
        removePage(id){
            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id)
            .then(response => {
                console.log(response)
                this.showModal = false
            })
        }
    },
    mounted(){
        this.selectfeature(this.pageid)
    }
}
</script>